var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTickWhiteFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 12",
    style: {
      enableBackground: "new 0 0 16 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "st0",
    d: "M0.2,6.6C0.1,6.5,0,6.3,0,6.2c0-0.1,0.1-0.3,0.2-0.4L1,4.9c0.2-0.2,0.6-0.2,0.9,0L2,5l3.4,3.5 c0.1,0.1,0.3,0.1,0.4,0L14,0.2h0.1c0.2-0.2,0.6-0.2,0.9,0L15.8,1c0.2,0.2,0.2,0.6,0,0.8L6,11.8C5.8,11.9,5.7,12,5.5,12 c-0.2,0-0.3-0.1-0.4-0.2l-4.8-5L0.2,6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTickWhiteFilter);
export default __webpack_public_path__ + "static/media/icTickWhiteFilter.e4f1bc62f967dbc0992ff8feb2874763.svg";
export { ForwardRef as ReactComponent };